import { DashboardMonitoringContainer } from "@/features/deployment-dashboard";

export function DashboardRoute() {
  return <DashboardMonitoringContainer />;
}
